import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/api/client";
import { mergeRemoteTranslations } from "@/i18n/config";
import { useTranslation } from "react-i18next";

const SettingsCtx = createContext({ settings: null, loading: true, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const { i18n } = useTranslation();

  const load = async () => {
    try {
      const { data } = await api.get("/public/settings");
      setSettings(data || {});
      // If i18n hasn't been explicitly set by user, honor default_language
      const hasUserPick = Boolean(localStorage.getItem("lp_lang"));
      if (!hasUserPick && data?.default_language) {
        i18n.changeLanguage(data.default_language);
      }
      // Merge admin-managed translations
      try {
        const t = await api.get("/public/translations");
        mergeRemoteTranslations(t.data);
      } catch (_) {}
    } catch (e) {
      setSettings({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <SettingsCtx.Provider value={{ settings, loading, refresh: load }}>{children}</SettingsCtx.Provider>
  );
}

export const useSettings = () => useContext(SettingsCtx);
